import { Phone } from "lucide-react";
import { CONTACT } from "./data";

export const MobileCallBar = () => {
  return (
    <a
      href={CONTACT.phoneHref}
      data-testid="mobile-call-bar"
      className="lg:hidden fixed bottom-4 left-4 right-4 z-40 inline-flex items-center justify-center gap-2.5 rounded-full bg-[#fcc41b] text-black font-display font-semibold text-base px-6 py-3.5 shadow-[0_10px_30px_rgba(0,0,0,0.5)] active:scale-[0.98] transition-transform duration-300"
      aria-label={`Call SolarArk on ${CONTACT.phone}`}
    >
      <Phone size={18} />
      Call {CONTACT.phone}
    </a>
  );
};
